import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaYoutube, FaTwitter, FaEnvelope, FaPhone } from 'react-icons/fa';
import logo from '../../assets/logo.png';
import BrandName from '../BrandName';

const GLP1Footer = () => {
  return (
    <footer className="bg-navy-800 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1: Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="Fitnession" className="h-10 w-auto" />
              <BrandName className="text-xl" />
              <span className="text-gold-500 text-sm font-semibold">GLP-1</span>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Medical weight loss for real Indians
            </p>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaInstagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaLinkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaYoutube size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaTwitter size={20} />
              </a>
            </div>
            <div className="space-y-2 text-sm">
              <a href="mailto:glp1@fitnession.fit" className="flex items-center hover:text-white">
                <FaEnvelope className="mr-2" /> glp1@fitnession.fit
              </a>
              <a href="tel:+919579520586" className="flex items-center hover:text-white">
                <FaPhone className="mr-2" /> +91 9579520586
              </a>
            </div>
          </div>

          {/* Column 2: Programs */}
          <div>
            <h4 className="text-white font-semibold mb-4">Programs</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://fitnession.fit" className="hover:text-white transition-colors">
                  Lifestyle Coaching
                </a>
              </li>
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  GLP-1 Program
                </Link>
              </li>
              <li>
                <a href="https://fitnession.fit/our-program" className="hover:text-white transition-colors">
                  Lifestyle Coaching Plans
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#how-it-works" className="hover:text-white transition-colors">How It Works</a></li>
              <li><Link to="/research" className="hover:text-white transition-colors">Research & Science</Link></li>
              <li><a href="/#pricing" className="hover:text-white transition-colors">Pricing</a></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQs</Link></li>
              <li><Link to="/eligibility" className="hover:text-white transition-colors">Check Eligibility</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog & Articles</Link></li>
            </ul>
          </div>

          {/* Column 4: Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/medical-disclaimer" className="hover:text-white transition-colors">Medical Disclaimer</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="text-center text-sm text-gray-500">
            <p className="mb-4">© 2026 Fitnession. All rights reserved.</p>
            <p className="text-xs max-w-3xl mx-auto">
              This service is not a substitute for professional medical advice. GLP-1 medications are prescription-only.
              Consult our licensed doctors for eligibility assessment. Results vary by individual.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default GLP1Footer;
